/**
 * Interface providing a set of methods to control
 * a widget instance.
 */

import type { WidgetTypesEnum } from '@core/types'
import type {
  WidgetInterruptCallbackFn,
  WidgetInterruptEvent,
} from '@core/widgets/interrupts/types'

import type { IWidget, IWidgetInstance } from './types'

/**
 * WidgetControl is a class that provides a set of methods to programmatically control
 * a widget instance via `_fwn.widgets`.
 */
export class WidgetControl implements IWidget {
  #instance: IWidgetInstance

  /**
   *
   */
  constructor(instance: IWidgetInstance) {
    this.#instance = instance
  }

  /**
   * Get the widget_id of the widget.
   */
  get widgetId(): string {
    return this.#instance.widgetId
  }

  /**
   * Get the name of the widget.
   */
  get name(): string {
    return this.#instance.name
  }

  /**
   * Get the type of the widget.
   */
  get type(): WidgetTypesEnum {
    return this.#instance.type
  }

  /**
   * Register an async callback to be called when an event occurs.
   */
  on(event: WidgetInterruptEvent, fn: WidgetInterruptCallbackFn) {
    this.#instance.registerCallback(event, fn)
  }

  /**
   * Unregister a callback from an event.
   */
  off(event: WidgetInterruptEvent) {
    this.#instance.unregisterCallback(event)
  }
}
